var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GET_ACTIVE_CARRIERS_REQUEST, getActiveCarriersFailure, getActiveCarriersSuccess } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
import { call, put, takeLatest } from "redux-saga/effects";
export const onGetActiveCarriers = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.get(`/rms/admin/active/carriers?tenantId=${action.payload.tenantId}`)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* getActiveCarriersWorker(action) {
    try {
        const data = yield call(onGetActiveCarriers, action);
        yield put(getActiveCarriersSuccess(data));
    }
    catch (error) {
        yield put(getActiveCarriersFailure(error));
    }
}
export function* watchGetActiveCarriersData() {
    yield takeLatest(GET_ACTIVE_CARRIERS_REQUEST, getActiveCarriersWorker);
}
